import React, { useState, useEffect, Fragment, useCallback } from 'react';
import {
    Card, CardBody, Button, TabContent, TabPane, NavItem, CardHeader, Nav, Row,
    UncontrolledDropdown,
    DropdownMenu,
    Input,
    CustomInput
} from 'reactstrap';
import { useDropzone } from 'react-dropzone'
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID, getUserID } from '../../../../../helpers/AxiosAPI';
import { gAPI_UserUploads, API_BMB_Font } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import SelectedImage from '../fonts/components/SelectedImage';


function Index({ propertyId, selectedImage, togglegallery, hideUserUploads, searchText, uploadLink }) {

    if (hideUserUploads === undefined) {
        hideUserUploads = false;
    }
    if (searchText === undefined) {
        searchText = '';
    }

    const [activeTab, setActiveTab] = useState('embed');
    const [loading, setLoading] = useState(true);
    const [bmbloading, setbmbLoading] = useState(true);
    const [photos, setphotos] = useState([]);
    const [bmbphotos, setbmbphotos] = useState([]);
    const [chosenImage, setchosenImage] = useState('');

    console.log(bmbphotos);
    const toggleAppMenu = tab => {
        setActiveTab(tab)
    };
    const [selectAll, setSelectAll] = useState(false);
    const imageRenderer = useCallback(
        ({ index, left, top, key, photo }) => (
            <SelectedImage
                selected={selectAll ? true : false}
                key={key}
                margin={"2px"}
                index={index}
                photo={photo}
                left={left}
                top={top}
                ParentImage={ParentImage}
                chosenImage={chosenImage}
                ParentDeleteImage={ParentDeleteImage}
                ParentEditImage={ParentEditImage}
            />
        )
    );

    const fileObj = [];
    const handleSubmit = () => {
        if (isAgree) {
            const data = new FormData();
            files.forEach(file => {
                data.append('files', file.img);
                data.append('tags', file.tags)
                data.append('captions', file.caption)
            });
            data.append('propertyId', propertyId)
            data.append('groupId', getGroupID());
            data.append('creator', 'dashboard');
            console.log(JSON.stringify(data));

            // setApiState("processing")
            AxiosAPI({
                method: 'post',
                url: `${API_BMB_Font}`,
                data: data,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(
                res => {
                    uploadLink(res);
                    togglegallery();
                    // setApiState('success')
                    // toggleModal();
                    // parentLoadData();
                },
                error => {
                    //  setApiState('fail')
                    console.log('eee.data', error.data);
                }
            );
        }
    };
    const [files, setFiles] = useState([]);
    const [isAgree, setAgree] = useState(false);
    const [errorModal, showErrorModal] = useState(false);
    const [ApiState, setApiState] = useState('default');
    const { getRootProps, getInputProps } = useDropzone({
        //accept: 'image/*',
        // accept: 'image/*,font/*',                              
        onDrop: acceptedFiles => {
            acceptedFiles.map(file => {
                if (file.name.includes('woff') || file.name.includes('ttf')) {
                    fileObj.push(
                        {
                            img: Object.assign(file, {
                                preview: URL.createObjectURL(file)
                            }),
                            tags: [],
                            caption: ''
                        });
                }
            });
            console.log(acceptedFiles);
            setFiles([...files, ...fileObj]);
        }
    });


    const ParentImage = (id) => {
        setchosenImage(id)
        let objIndex = bmbphotos.findIndex((obj => obj.id == id));
        bmbphotos[objIndex].selected = true;
        setbmbphotos(bmbphotos)
    }

    const ParentDeleteImage = (id) => {
        const values = [...bmbphotos];
        let objIndex = bmbphotos.findIndex((obj => obj.id == id));
        values.splice(objIndex, 1);
        setbmbphotos(values)
    }

    const ParentEditImage = (id, tags) => {
        let objIndex = bmbphotos.findIndex((obj => obj.id == id));
        bmbphotos[objIndex].tags = true;
        setbmbphotos(bmbphotos)
    }

    const ParentUserDeleteImage = (id) => {
        const values = [...photos];
        let objIndex = photos.findIndex((obj => obj.id == id));
        values.splice(objIndex, 1);
        setphotos(values)
    }

    const ParentUserEditImage = (id, tags) => {
        let objIndex = photos.findIndex((obj => obj.id == id));
        photos[objIndex].tags = true;
        setphotos(photos)
    }

    const ParentUserUploadImage = (id) => {
        setchosenImage(id)
        let objIndex = photos.findIndex((obj => obj.id == id));
        photos[objIndex].selected = true;
        setphotos(photos)
    }

    const AddImage = () => {
        let objIndex = bmbphotos.findIndex((obj => obj.id == chosenImage));
        selectedImage(bmbphotos[objIndex]);
        togglegallery()
    }

    const AddUserImage = () => {
        let objIndex = photos.findIndex((obj => obj.id == chosenImage));
        selectedImage(photos[objIndex]);
        togglegallery()
    }


    return (
        <Fragment>
            <CardHeader className="pl-0 pr-0">
                <Nav tabs className="card-header-tabs ml-0 mr-0">

                    <NavItem className="w-100 text-center">
                        <NavLink
                            className={classnames({
                                active: activeTab === "embed",
                                "nav-link": true
                            })}
                            onClick={() => {
                                toggleAppMenu("embed");
                            }}
                            to="#"
                        >
                            My Uploads
                        </NavLink>
                    </NavItem>
                </Nav>
            </CardHeader>

            <TabContent
                activeTab={activeTab}
                className=""
            >
                <TabPane tabId="embed" className="chat-app-tab-pane">
                    <Card className="mb-4">
                        <CardBody>
                            <Row className="mt-3">
                                <Colxx xxs="12">
                                    <Fragment>
                                        <Row className="mb-4">
                                            <section className="container">
                                                <div {...getRootProps({ className: 'dropzone' })}>
                                                    <input {...getInputProps()} />
                                                    <div class="dz-default dz-message">
                                                        <span>Drop files here to upload, or click to select files. Recommended upload limit of 10MB per file. Supported formats: TTF, WOFF.

                                                        </span>
                                                        <p className="font-weight-medium mb-0 ">
                                                            <i className="demo-icon simple-icon-cursor-move"></i>
                                                        </p>
                                                    </div>

                                                </div>
                                                <div className="filepicker dropzone-gallery dz-clickable dz-started" style={{ minHeight: '160px', border: '0px' }}
                                                >
                                                    {files.map((file, index) => (
                                                        <div className="dz-preview dz-file-preview mb-3" key={index}>
                                                            <div className="row">
                                                                <div className="p-0 w-30 position-relative">
                                                                    <div className="preview-container">
                                                                        <img data-dz-thumbnail className="img-thumbnail border-0" src={file.img.preview} style={{ display: 'block' }} />
                                                                    </div>
                                                                </div>
                                                                <div className="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                                                                    <div>
                                                                        {" "}
                                                                        <span data-dz-name>{file.img.name}</span>{" "}
                                                                    </div>
                                                                    <div className="text-primary text-extra-small" data-dz-size>{file.img.size}</div>
                                                                </div>

                                                            </div>

                                                            {/* <a href="#/" className="remove" data-dz-remove
                                                                onClick={() => handleRemoveFields(index)}
                                                            >
                                                                {" "}
                                                                <i className="glyph-icon simple-icon-trash" />{" "}
                                                            </a> */}
                                                        </div>

                                                    ))}
                                                </div>
                                            </section>
                                        </Row>
                                        <div className='d-flex text-center ml-0 font-weight-bold mt-1 mb-2' style={{ justifyContent: 'center' }}>
                                            <CustomInput
                                                type="checkbox"
                                                id="agree"
                                                value={isAgree}
                                                checked={isAgree}
                                                onChange={(e) => {
                                                    setAgree(!isAgree);
                                                }}
                                            >
                                                <span className='mt-1' style={{ verticalAlign: 'sub' }}>I have copyright or permissions to use this font</span>

                                            </CustomInput>
                                        </div>
                                        <div className='mt-2 d-flex' style={{ justifyContent: 'center' }}>
                                            <Button color="primary" onClick={handleSubmit}
                                                className={`btn-multiple-state text-white ${classnames(
                                                    {
                                                        "show-spinner": ApiState === "processing",
                                                        "show-success": ApiState === "success",
                                                        "show-fail": ApiState === "fail"
                                                    }
                                                )}`}
                                            >
                                                <span className="spinner d-inline-block">
                                                    <span className="bounce1" />
                                                    <span className="bounce2" />
                                                    <span className="bounce3" />
                                                </span>
                                                <span className="icon success">
                                                    <i className="simple-icon-check" />
                                                </span>
                                                <span className="icon fail">
                                                    <i className="simple-icon-exclamation" />
                                                </span>
                                                <span className="label">Save</span>
                                            </Button>

                                        </div>
                                    </Fragment>
                                </Colxx>
                            </Row>
                        </CardBody>
                    </Card>
                </TabPane>
            </TabContent>
        </Fragment>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId, email } = settings;
    return {
        propertyId, email
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
